export default [
  {
    "x": 170.529336,
    "y": 1.73241299,
    "angle": -2.8932503792283186,
    "lengthA": 45.14570421339916,
    "lengthB": 45.14687999610539
  },
  {
    "x": 296.375041,
    "y": 133.184301,
    "angle": -1.387453942194026,
    "lengthA": 49.53094013398736,
    "lengthB": 49.52982681197764
  },
  {
    "x": 221.355331,
    "y": 209.007966,
    "angle": -0.5184527561499258,
    "lengthA": 33.58764772165982,
    "lengthB": 33.58926264049635
  },
  {
    "x": 187.260979,
    "y": 247.987833,
    "angle": 0.023356126631925576,
    "lengthA": 26.40271112630256,
    "lengthB": 26.402710126575307
  },
  {
    "x": 104.657734,
    "y": 189.282137,
    "angle": 0.08198125514067507,
    "lengthA": 37.63504134987032,
    "lengthB": 37.637553805907366
  },
  {
    "x": 33.8048415,
    "y": 50.5779371,
    "angle": 2.369911777243777,
    "lengthA": 130.83502811320375,
    "lengthB": 21.032883363871186
  }
]